/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DictPropertyCategory
 */
export interface DictPropertyCategory {
    /**
     * 
     * @type {string}
     * @memberof DictPropertyCategory
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof DictPropertyCategory
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof DictPropertyCategory
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DictPropertyCategory
     */
    namePlural: string;
}

export function DictPropertyCategoryFromJSON(json: any): DictPropertyCategory {
    return DictPropertyCategoryFromJSONTyped(json, false);
}

export function DictPropertyCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DictPropertyCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'id': json['id'],
        'namePlural': json['namePlural'],
    };
}

export function DictPropertyCategoryToJSON(value?: DictPropertyCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'id': value.id,
        'namePlural': value.namePlural,
    };
}


